import { createAction } from "@reduxjs/toolkit";

// Action to reset all slices
export const reset = createAction("reset");
export const resetSelectedSlices = createAction<string[]>("RESET_SELECTED_SLICES");
